import { IconProps } from "../types/icon";

export const CloseIcon = ({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      aria-hidden
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeWidth="2"
        d="M6 6l12 12M18 6 6 18"
      />
    </svg>
  );
};
